import { createSlice, isRejectedWithValue, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../state/store';

export interface Error {
  statusCode: number;
  error: string;
  message: string | string[];
}

interface ErrorPayload {
  data: Error;
}

const errorSlice = createSlice({
  name: 'errors',
  initialState: { data: null as Error | null },
  reducers: {
    clearError(state) {
      state.data = null;
    },
  },
  extraReducers: builder =>
    builder.addMatcher(isRejectedWithValue, (state, action: PayloadAction<unknown>) => {
      const payload = action.payload as ErrorPayload;
      const status = payload?.data?.statusCode as number | undefined;
      if (status !== 401) {
        state.data = payload.data;
      }
    }),
});

export const selectError = (state: RootState) => state.errors.data;

export const { clearError } = errorSlice.actions;

export default errorSlice.reducer;
